import { render, staticRenderFns } from "./LoginSignupPage.vue?vue&type=template&id=4a0f42f3&scoped=true"
import script from "./LoginSignupPage.vue?vue&type=script&lang=js"
export * from "./LoginSignupPage.vue?vue&type=script&lang=js"
import style0 from "./LoginSignupPage.vue?vue&type=style&index=0&id=4a0f42f3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a0f42f3",
  null
  
)

export default component.exports